import {Aggregator} from "./aggregator"

export enum AggregateFunctionType {
    SUM                     = 'sum',
    MIN                     = 'min',
    MAX                     = 'max',
    MEDIAN                  = 'median',
    AVERAGE                 = 'average',

    CHECKED_TOTAL           = 'checkedTotal',

    SUMMARY_COUNT           = 'summary-count',      // used for objects counts like status dict ID->how many items or priority -> how many items

    TOTAL_SPENT_ESTIMATE    = 'total-spent-estimate',

    DATE_MIN                = 'date-min',
    DATE_MAX                = 'date-max',
    DATE_RANGE              = 'range',

    USERS_UNION             = 'users-union',    // union of user ID sets across children
}

export type Aggregators = {
    [fieldId: fieldId]  : Aggregator
}

export const AggregateFunctionName = {
    [AggregateFunctionType.SUM]                     : 'Sum',
    [AggregateFunctionType.MIN]                     : 'Minimum',
    [AggregateFunctionType.MAX]                     : 'Maximum',
    [AggregateFunctionType.MEDIAN]                  : 'Median',
    [AggregateFunctionType.AVERAGE]                 : 'Average',
    [AggregateFunctionType.CHECKED_TOTAL]           : 'Checked',

    [AggregateFunctionType.SUMMARY_COUNT]           : 'Summary',
    [AggregateFunctionType.TOTAL_SPENT_ESTIMATE]    : 'Total',

    [AggregateFunctionType.DATE_MIN]                : 'Minimum',
    [AggregateFunctionType.DATE_MAX]                : 'Maximum',
    [AggregateFunctionType.DATE_RANGE]              : 'Range',

    [AggregateFunctionType.USERS_UNION]             : 'Union',
}

export const AggregateFunctionLabel = {
    [AggregateFunctionType.SUM]                     : 'Sum',
    [AggregateFunctionType.MIN]                     : 'Min',
    [AggregateFunctionType.MAX]                     : 'Max',
    [AggregateFunctionType.MEDIAN]                  : 'Med',
    [AggregateFunctionType.AVERAGE]                 : 'Avg',
    [AggregateFunctionType.CHECKED_TOTAL]           : '',

    [AggregateFunctionType.SUMMARY_COUNT]           : '',
    [AggregateFunctionType.TOTAL_SPENT_ESTIMATE]    : '',

    [AggregateFunctionType.DATE_MIN]                : 'Min',
    [AggregateFunctionType.DATE_MAX]                : 'Max',
    [AggregateFunctionType.DATE_RANGE]              : '',

    [AggregateFunctionType.USERS_UNION]             : '',
}